<div
  [ngClass]="[
    card_wrap ? 'card' : '',
    card_wrap && !is_offcanvas ? 'shadow-sm' : '',
    is_offcanvas ? 'border-0 rounded-0' : '',
    class
  ]"
>
  <div [ngClass]="{ 'card-body': card_wrap, 'p-0': is_offcanvas }">
    <h4 *ngIf="header" class="mb-3" [ngClass]="{ 'card-title': card_wrap }">{{ header }}</h4>

    <div
      [tds-data-loader]="{
        key: 'asset-item',
        class: 'col w-100 py-4',
        size: 'lg'
      }"
    >
      <div
        *ngIf="asset"
        class="card overflow-hidden"
        [ngClass]="{ 'border-0 rounded-0 p-0': is_offcanvas }"
      >
        <div class="card-body card-items card-items-md asset-card__details">
          <div
            *ngIf="asset.line && asset.line.is_primary_contact && !is_offcanvas"
            class="position-absolute top-0 start-0 asset-card__primary"
            aria-label="Primary line"
          >
            <span class="material-icons">verified</span>
          </div>
          <ts-asset-selection-item
            [asset]="asset"
            [additional_asset]="additional_asset"
            [additional_asset_type]="additional_asset_type"
            [asset_fields]="asset_fields"
            [is_offcanvas]="is_offcanvas"
          />
        </div>
      </div>

      <ng-container *ngTemplateOutlet="extra_content; context: { $implicit: extras, asset }" />
    </div>
  </div>
</div>
